// Calcula si un color de fondo es "claro" u "oscuro" (luminancia relativa)
// y regresa la paleta de texto/iconos que mantiene buen contraste sobre él.
// Así, si el administrador elige un color claro para la barra de
// navegación, el texto cambia solo a oscuro en vez de volverse ilegible.

function hexToRgb(hex) {
  const clean = hex.replace("#", "");
  const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
  const num = parseInt(full, 16);
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

function relativeLuminance({ r, g, b }) {
  const [rs, gs, bs] = [r, g, b].map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

export function isLightColor(hex) {
  try {
    return relativeLuminance(hexToRgb(hex)) > 0.5;
  } catch {
    return false;
  }
}

export function navPalette(bgColor, brandTokens) {
  const light = isLightColor(bgColor);
  if (!light) {
    // Paleta oscura de siempre (la que ya existía).
    return {
      textPrimary: "#EDEFE6",
      textMuted: "#9AA6B8",
      navInactive: "#C7CDD9",
      activeBg: "rgba(185,129,46,0.16)",
      activeText: brandTokens.brassSoft,
      hoverBg: "rgba(255,255,255,0.06)",
      chipBg: "rgba(185,129,46,0.16)",
      logoutBg: "rgba(255,255,255,0.08)",
      borderColor: "rgba(255,255,255,0.12)",
    };
  }
  // Paleta clara: se activa sola cuando el color elegido es claro.
  return {
    textPrimary: brandTokens.ink,
    textMuted: brandTokens.inkSoft,
    navInactive: brandTokens.inkSoft,
    activeBg: "rgba(185,129,46,0.22)",
    activeText: "#8A5B18",
    hoverBg: "rgba(0,0,0,0.04)",
    chipBg: "rgba(185,129,46,0.22)",
    logoutBg: "rgba(0,0,0,0.06)",
    borderColor: "rgba(0,0,0,0.1)",
  };
}
